import { z } from 'zod';

/** SeoSchema — SEO fields for wallpapers_i18n and categories_i18n */
export const seoSchema = z.object({
  title: z.string().optional(),
  description: z.string().optional(),
  h1: z.string().optional(),
  seo_text: z.string().optional(),
});
export type SeoData = z.infer<typeof seoSchema>;

/**
 * RawDescriptionOutput — raw output from Step1Describe (Vision analysis step).
 * Contains image analysis and raw description.
 * Stored in wallpaper_raw_descriptions table.
 */
export const RawDescriptionOutput = z.object({
  wallpaper_id: z.number().int().positive(),
  image_url: z.string().url(),
  main_subject: z.string().optional(),
  style: z.string().optional(),
  mood: z.string().optional(),
  palette: z.string().optional(),
  brightness: z.string().optional(),
  dominant_colors: z.string().optional(),
  details: z.record(z.unknown()).optional(),
  small_details: z.record(z.unknown()).optional(),
  description: z.string().optional(),
  generated_at: z.string().datetime(),
});
export type RawDescriptionOutput = z.infer<typeof RawDescriptionOutput>;

/**
 * RawDescription — strict version (all fields required).
 * Stored in wallpaper_raw_descriptions after successful Step1Describe processing.
 */
export const RawDescription = z.object({
  wallpaper_id: z.number().int().positive(),
  image_url: z.string().url(),
  main_subject: z.string().min(1),
  style: z.string().min(1),
  mood: z.string().min(1),
  palette: z.string().min(1),
  brightness: z.string().min(1),
  dominant_colors: z.string().min(1),
  details: z.record(z.unknown()),
  small_details: z.record(z.unknown()),
  description: z.string().min(1),
  generated_at: z.string().datetime(),
});
export type RawDescription = z.infer<typeof RawDescription>;

/**
 * MetaTags — SEO output from Step2Seo (metadata generation step).
 * Used in wallpapers_i18n seo columns.
 */
export const MetaTags = z.object({
  title: z.string().min(1).max(70),
  description: z.string().min(1).max(160),
  h1: z.string().min(1).max(100),
  uri: z.string().regex(/^[a-z0-9]+(?:-[a-z0-9]+)*(?:\/[a-z0-9]+(?:-[a-z0-9]+)*)*$/, 'Invalid URI slug'),
  seo_text: z.string().optional(),
});
export type MetaTags = z.infer<typeof MetaTags>;
